import React from 'react';

import { useReactNodeView } from '@lyearn/lygo-core';

import TabsComponentEditable from './TabsEditable';
import TabsComponentReadOnly from './TabsReadOnly';

const TabsNodeView: React.FC = () => {
  const { node, view } = useReactNodeView();

  if (!view?.editable) {
    return <TabsComponentReadOnly {...node?.attrs} />;
  }

  return <TabsComponentEditable {...node?.attrs} />;
};

export default TabsNodeView;
